
    const varsViewer = document.querySelector('custom-vars-viewer');
    const options = {
        rootMargin: '20px'
    }
    const callback = async (entries, observer) => {
        if (entries[0].intersectionRatio === 0) return;
        import('@spectrum-web-components/custom-vars-viewer/custom-vars-viewer.js').then(() => {
            const queryThemeEvent = new CustomEvent('sp-track-theme', {
                bubbles: true,
                composed: true,
                detail: {
                    callback: (color) => {
                        varsViewer.themeColor = color.startsWith('light')
                            ? 'light'
                            : color;
                    },
                },
                cancelable: true,
            });
            varsViewer.dispatchEvent(queryThemeEvent);
        });
        observer.disconnect();
    }

    const observer = new IntersectionObserver(callback, options);
    observer.observe(varsViewer);
